<template>
  <section id="order">


    <div class="wizard">

      <div class="summary">
        <div class="from">
          <div class="label">{{ $t('views.order.original') }}</div>
          <img :src="order.from.image">
          <div class="meta">
            <div class="name">{{order.from.filename}}</div>
          </div>
        </div>

        <div class="to">
          
          <div class="label">{{ $t('views.order.adaptation') }}</div>
          <div class="item" v-if="order.to.file"><label>{{ $t('general.format') }}</label><span class="value">{{types[order.to.file].name}}</span></div>
          <div class="item" v-if="order.to.filename"><label>{{ $t('general.dimensions') }}</label><span class="value">{{sizes[order.to.file][order.to.filename].name}} <span v-if="sizes[order.to.file][order.to.filename].custom"><br/>{{order.to.size}}</span></span></div>
          <div class="item"><label>{{ $t('general.personalization') }}</label><span v-if="order.custom == {}" class="value">{{ $t('general.no_personalization') }}</span></div>
          <div class="item" v-if="order.custom.restaurant != ''"><label>* {{ $t('general.restaurant') }}</label><span class="value">{{ order.custom.restaurant }}</span></div>
          <div class="item" v-if="order.custom.price"><label>* {{ $t('general.price') }}</label><span class="value">{{ order.custom.price }}</span></div>
          <div class="item" v-if="order.custom.legal"><label>* {{ $t('views.order.customize.legal') }}</label><span class="value">{{ order.custom.legal }}</span></div>
          <div class="item" v-if="order.custom.schedule"><label>* {{ $t('general.schedule') }}</label><span class="value">{{ order.custom.schedule }}</span></div>
          <div class="item" v-if="order.custom.date"><label>* {{ $t('general.date') }}</label><span class="value">{{ order.custom.date }}</span></div>
          <div class="item" v-if="order.custom.others"><label>* {{ $t('general.others') }}</label><span class="value">{{ order.custom.others }}</span></div>

        </div>

      </div>
      <div class="box">
        <div v-if="page == 1" class="step" data-id="1">
          <h2 class="title">{{ $t('views.order.title.piece') }}</h2>
          <div class="desc">{{ $t('views.order.description.piece') }}</div>

          <div class="file-type">
            <select v-model="order.to.file" @change="cleanFile()">
              <option v-for="option in sorted_types" :value="option.id">{{ /* (option.id == order.from.type)? "MISMO FORMATO" : */ option.name }}</option>
            </select>
          </div>
          
        </div>

        <div v-else-if="page == 2" class="step" data-id="2">
          <h2 class="title">{{ $t('views.order.title.material') }}</h2>
          <div class="desc">{{ $t('views.order.description.material') }}</div>

          <div class="file-size">
            <select v-model="order.to.filename" >
              <option v-for="option in sizes[order.to.file]" :value="option.id" >{{ option.name }}</option>
            </select>
            <div v-if="order.to.filename && sizes[order.to.file][order.to.filename].custom">
              <div class="subtitle">{{ $t('views.order.footer.dimensions') }}</div>
              <div class="caption">{{ $t('views.order.footer.size') }}</div>
              <input v-model="order.to.size" type="text" name="">
            </div>
          </div>
          
        </div>

        <div v-else-if="page == 3" class="step" data-id="3">
          <div v-show="order.to.file && questions[ order.to.file ].q1">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.coupon') }}</h2>
                <v-radio-group v-model="order.params.q1" :mandatory="true" row class="justify-center">
                  <v-radio label="Sí" value="1"></v-radio>
                  <v-radio label="No" value="0"></v-radio>
                </v-radio-group>
              </div>

              <div class="question">
                <h2 class="title">{{ $t('views.order.title.trolley') }}</h2>
                <v-radio-group v-model="order.params.q2" :mandatory="true" row class="justify-center">
                  <v-radio label="Sí" value="1"></v-radio>
                  <v-radio label="No" value="0"></v-radio>
                </v-radio-group>
              </div>

              <div class="question">
                <h2 class="title">{{ $t('views.order.title.custom') }}</h2>
                <div class="desc">{{ $t('views.order.description.custom') }}</div>
                <textarea v-model="order.params.custom" placeholder="" rows="5" cols="5"></textarea>
              </div>
          </div>
          
          <div v-show="order.to.file &&questions[ order.to.file ].q2">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.rounded') }}</h2>
                <v-radio-group v-model="order.params.q4" :mandatory="true" row class="justify-center">
                  <v-radio label="Sí" value="1"></v-radio>
                  <v-radio label="No" value="0"></v-radio>
                </v-radio-group>
              </div>
          </div>

          <div v-show="order.to.file &&questions[ order.to.file ].q3">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.newspaper') }}</h2>
                <v-radio-group v-model="order.params.q5" :mandatory="true" row class="justify-center">
                  <v-radio label="Revista" value="1"></v-radio>
                  <v-radio label="Periódico" value="0"></v-radio>
                </v-radio-group>
              </div>
          </div>

          <div v-show="order.to.file &&questions[ order.to.file ].q4">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.support') }}</h2>
                <v-radio-group v-model="order.params.q6" :mandatory="true" row class="justify-center">
                  <v-radio label="Sí" value="1"></v-radio>
                  <v-radio label="No" value="0"></v-radio>
                </v-radio-group>
              </div>
          </div>

          <div v-show="order.to.file &&questions[ order.to.file ].q5">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.peana') }}</h2>
                <v-radio-group v-model="order.params.q7" :mandatory="true" row class="justify-center">
                  <v-radio label="Sí" value="1"></v-radio>
                  <v-radio label="No" value="0"></v-radio>
                </v-radio-group>
              </div>
          </div>

          <div v-show="order.to.file &&questions[ order.to.file ].q6">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.envelope') }}</h2>
                <v-radio-group v-model="order.params.q8" :mandatory="true" row class="justify-center">
                  <v-radio label="Sí" value="1"></v-radio>
                  <v-radio label="No" value="0"></v-radio>
                </v-radio-group>
              </div>
          </div>

          <div v-show="order.to.file &&questions[ order.to.file ].q7">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.prices') }}</h2>
                <div class="desc">{{ $t('views.order.description.prices') }}</div>
                <input type="file" id="input-file-question" @change="loadFile('input-file-question')" name="">
              </div>
          </div>

          <div v-show="order.to.file &&questions[ order.to.file ].q8">
              <div class="question">
                <h2 class="title">{{ $t('views.order.title.materials') }}</h2>
                <textarea v-model="order.params.custom" placeholder="" rows="5" cols="5"></textarea>
              </div>
          </div>
          
        </div>

        <div v-else-if="page == 4" class="step" data-id="4">
          <h2 class="title">{{ $t('views.order.title.customize') }}</h2>
          <div v-if="description[order.to.file]" class="desc">{{description[order.to.file]}}</div>
          <div v-else class="desc">{{ $t('views.order.description.customize') }}</div>

          <div class="file-customize">
            <label for="price"><b>{{ $t('general.price') }}</b> {{ $t('views.order.customize.price') }}</label>
            <input type="text" id="price" v-model="order.custom.price" :placeholder="$t('general.price_simple')" @focus="focusPrice = true" @blur="focusPrice = false"></input>

            <transition-group name="fade">
              <label key="label" for="legal" v-if="computedPrice"><b>{{ $t('views.order.customize.legal') }}<span class="required">*</span>:</b> {{ $t('views.order.customize.legal_description') }}</label>
              <input key="input" type="text" id="legal" v-model="order.custom.legal" :placeholder="$t('views.order.customize.legal_placeholder')" rows="2" cols="5" v-if="computedPrice" :mandatory="true"></input>
            </transition-group>
            <!-- <input type="text" v-model="order.custom.date" placeholder="Fecha"></input> -->
            <label for="restaurant" v-html="$t('views.order.customize.restaurant')"></label>
            <input v-if="market == 'ES'" type="text" id="restaurant" v-model="order.custom.restaurant" :placeholder="$t('admin.restaurant.name')"></input>
            <div v-else class="container">
              <select v-model="order.custom.restaurant">
                <option v-for="option in locations" :value="option.name">{{ option.site }} - {{ option.name }} {{ option.cif }} {{ option.razon }}</option>
              </select>
            </div>
            
            <!-- <textarea v-model="order.custom.schedule" placeholder="Horario" rows="2" cols="5"></textarea> -->
            <label for="restaurant"><b>{{ $t('general.others') }}</b> {{ $t('views.order.customize.others') }}</label>
            <textarea v-model="order.custom.others" id="other" :placeholder="$t('general.others_placeholder')" rows="2" cols="5"></textarea>

            <label for="date" v-if="market == 'PT'"><b>{{ $t('views.order.customize.start_date') }}</b></label>
            <input type="date" id="date" v-model="order.custom.start_date" :placeholder="$t('views.order.customize.start_date')" v-if="market == 'PT'"></input>
            <label for="date" v-if="market == 'PT'"><b>{{ $t('views.order.customize.end_date') }}</b></label>
            <input type="date" id="date" v-model="order.custom.end_date" :placeholder="$t('views.order.customize.end_date')" v-if="market == 'PT'"  ></input>

            <label for="date" v-if="market == 'PT'">
              <b>{{ $t('general.direction') }}</b> {{ $t('views.order.customize.direction') }}
            </label>

            <v-select
              v-model="order.custom.direction"
              :items="directions"
              item-value="value"
              return-object
              item-text="text"
              :placeholder="$t('views.order.customize.direction_placeholder')"
              dense
              clearable
              class="direction-select"
              v-if="market == 'PT'"
            >

              <!-- Custom item display in dropdown -->
              <template slot="item" slot-scope="data">
                <div class="d-flex align-center">
                  <img v-if="data.item.image" :src="data.item.image" alt="" height="24" class="mr-2" />
                  <span>{{ data.item.text || $t('views.order.customize.direction_placeholder') }}</span>
                </div>
              </template>

              <!-- Custom selected item display -->
              <template slot="selection" slot-scope="data">
                <template v-if="data.item && data.item.text">
                  <v-chip small>
                    <v-avatar left>
                      <img :src="data.item.image" alt="" />
                    </v-avatar>
                    {{ data.item.text }}
                  </v-chip>
                </template>
                <template v-else>
                  <span class="grey--text">{{ $t('views.order.customize.direction_placeholder') }}</span>
                </template>
              </template>
            </v-select>

            <div v-if="personalization[order.to.file]" class="desc"></div>
            <div v-if="personalization[order.to.file]" class="desc">{{ $t('views.order.customize.download') }}</div>
            
            <label for="input-file-customize">{{ $t('views.order.customize.input') }}</label>
            <input type="file" id="input-file-customize" @change="loadFile('input-file-customize')" name="">
          </div>
          
        </div>


        <div v-else-if="page == 5 && this.market == 'ES'" class="step" data-id="5">
          <h2 class="title">{{ $t('views.order.title.budget') }}</h2>
          <br/><br/>
          <div class="question">

            <v-radio-group v-model="order.method" :mandatory="true" class="justify-center">
              <v-radio label="Adaptación arte final" value="1"></v-radio>
              <v-radio label="Adaptación arte final + presupuesto producción" value="2"></v-radio>
            </v-radio-group>
            <div v-show="order.method == '2'" class="param units">
                <div class="label">{{ $t('general.unit_scale') }}</div>
                <div class="container">
                  <select v-model="order.units_scale" placeholder="Seleccione el escalado" style="width: 50%;min-width: 150px;">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="250 - 500">250 - 500</option>
                    <option value="500 - 1000">500 - 1000</option>
                    <option value="1000 - 2000">1000 - 2000</option>
                    <option value="2000 - 3000">2000 - 3000</option>
                    <option value="3000 - 4000">3000 - 4000</option>
                    <option value="4000 - 5000">4000 - 5000</option>
                    <option value="-1">{{ $t('general.personalized') }}</option>
                  </select>
                  <input v-show="order.units_scale == -1" v-model="order.units_scale_custom" type="text" class="units single"> {{ $t('general.units') }}
                </div>
            </div>
          </div>
          <div class="box-info" v-if="this.market == 'ES'">
            <h2 class="title">{{ $t('views.order.prices.title') }}</h2>
            <p><span class="subtitle">{{ $t('views.order.prices.text') }}</span>{{ $t('views.order.prices.description.text') }}</p>

            <p><span class="subtitle">{{ $t('views.order.prices.signal') }}</span>{{ $t('views.order.prices.description.signal') }}</p>

            <p><span class="subtitle">{{ $t('views.order.prices.double') }}</span>{{ $t('views.order.prices.description.double') }}</p>
            <p>{{ $t('views.order.prices.description.double_description') }}</p>

            <p><span class="subtitle">{{ $t('views.order.prices.triple') }}</span>{{ $t('views.order.prices.description.triple') }}</p>
            <br>
            <p>{{ $t('views.order.prices.description.triple_description') }}</p>
          </div>
          
        </div>

        <div v-show="error_message" class="message error fadeIn">{{error_message}}</div>

        <div class="buttons">
          <div v-show="page > 1" class="bttn previous" @click="previous()">{{ $t('general.back') }}</div>
          <div class="bttn next" @click="next()">{{next_bttn}}</div>
        </div>

      </div>
        
      </div>
      


  </section>
</template> 

<script>
import i18n from '@/i18n';

export default {
  name: 'Order',
  props: {id: String, type: String},
  data () {
    return {
      page: 1,
      total: 5,
      order: {from: { file: this.$route.params.id, filename: 'Instagram image', image: 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/10/5d/98/105d9875-89ad-bb9f-1f20-6abcb724875c/AppIcon-0-1x_U007emarketing-0-0-85-220-0-8.png/246x0w.jpg'}, to: { file: false, filename: false, size: ''}, method: false, units: false, units_scale: false, units_scale_custom: "", billed: false, shipped: false, custom_ship: '', custom: { }, custom_file: null, params: {}},
      error_message : false,
      sizes: this.$store.getters['orders/getSizes'],
      questions: this.$store.getters['orders/getQuestions'],
      personalization: this.$store.getters['orders/getPersonalizations'],
      description: this.$store.getters['orders/getDescriptions'],
      next_bttn: 'Continuar',
      focusPrice: false,
      directions: [
        { text: '', value: null, image: null},
        { text: '#1 Seta em Frente', value: 1, image: process.env.VUE_APP_BASE_URL + '/img/up.svg'},
        { text: '#2 Seta para a Direita', value: 2, image: process.env.VUE_APP_BASE_URL + '/img/right.svg'},
        { text: '#3 Seta para a Esquerda', value: 3, image: process.env.VUE_APP_BASE_URL + '/img/left.svg'},
        { text: '#4 Seta Curva a Direita', value: 4, image: process.env.VUE_APP_BASE_URL + '/img/turn-right.svg'},
        { text: '#5 Seta Curva a Esquerda', value: 5, image: process.env.VUE_APP_BASE_URL + '/img/turn-left.svg'},
        { text: '#6 Seta Retorno', value: 6, image: process.env.VUE_APP_BASE_URL + '/img/return.svg'},
        { text: '#7 Rotunda Saida a Direita', value: 7, image: process.env.VUE_APP_BASE_URL + '/img/roundabout-right.svg'},
        { text: '#8 Rotunda Saida em Frente', value: 8, image: process.env.VUE_APP_BASE_URL + '/img/roundabout-straight.svg'},
        { text: '#9 Rotunda Saida a Esquerda', value: 9, image: process.env.VUE_APP_BASE_URL + '/img/roundabout-left.svg'},
        { text: '#10 Rotunda Retorno Completo', value: 10, image: process.env.VUE_APP_BASE_URL + '/img/roundabout-return.svg'}
      ]
    }
  },
  computed: {
    types() {
      var types = (this.$store.getters['files/getTypesCustomizable']);
      return types;

    },
    sorted_types() {
      return Object.values(this.types);

      var types = [...Object.values(this.types)];

      this.types[this.order.from.type].name = "Mismo formato";

      types.sort(function(a,b){
        if(a.name < b.name ) return -1;
        else return 1;
      });
      return types;
    },
    computedPrice(){
      console.log('this.order', this.order.custom.price);
      return this.order.custom.price || this.focusPrice || this.order.custom.legal;
    },
    market() {
      return this.$store.getters['getMarket'];
    },
    locations() {
      return this.$store.getters['locations/getLocations']
    },
  },
  methods: {
    next() {
      if( !document.getElementsByClassName( 'next' )[0].classList.contains( 'disabled' ) ){
        console.log( "PAG: " + this.page );
        console.log( this.order );
        var error = false;
        switch(this.page) {
          case 1:
            if(!this.order.to.file) error = i18n.t('views.order.error.format');
            break;
          case 2:
            if(!this.order.to.filename) error = i18n.t('views.order.error.size');
            if(this.order.to.filename && this.sizes[this.order.to.file][this.order.to.filename].custom && !this.order.to.size.trim()) error = i18n.t('views.order.error.size');
            break;
          case 3:
            if(!this.order.to.file) error = i18n.t('views.order.error.format');
            break;
           case 4:
           /* if(this.market == 'PT') {
            if(!this.order.custom.others) error = i18n.t('views.order.others_error');
            if(!this.order.custom.restaurant || this.order.custom.restaurant.trim() === '') error = i18n.t('views.order.restaurant_error');
            if(!this.order.custom.price || this.order.custom.price.trim() === '') error = i18n.t('views.order.price_error');
           } */
            if(!this.order.custom.legal && this.computedPrice) error = i18n.t('views.order.legal_error');
            if( this.personalization[this.order.to.file] && !this.order.custom_file ) error = i18n.t('views.order.error.customize');
            break;
          case 5: console.log( "METHOD: " + this.order.method );
            if(!this.order.method) error = i18n.t('views.order.error.budget');
            break;
          default:
            break;
        }
        //this.error_message = "No has completado todos los campos";

        if(error) {
          this.error_message = error;
          var self = this;
          setTimeout(function(){ self.error_message = false; }, 3000);
        }
        else{
          if( this.page == 1 && ( this.order.to.file == this.order.from.type ) && this.market == 'ES' ){
              this.page = 4;
              return;
          }

          if( this.page == 1 && ( typeof this.sizes[ this.order.to.file ] == 'undefined' || Object.keys( this.sizes[ this.order.to.file ] ).length == 0 ) ){
              this.page++;
          }

          if( this.page == 2 && ( typeof this.questions[ this.order.to.file ] == 'undefined' || Object.keys( this.questions[ this.order.to.file ] ).length == 0 ) ){
              this.page++;
          }
          if(this.page == 4 && this.market == 'PT') {
            this.page++;
            this.order.method = "1";
          }
          if(this.page == this.total) {
              if( this.type == 'new' ){
                  this.$store.commit( 'orders/addOrderToCart', this.order );
              }
              else {
                  this.$store.commit( 'orders/editOrder', this.order );
              }
              
              this.$store.commit( 'files/unsetCurrentFile' );
              this.$router.push( { name: 'cart' } );
              this.$destroy();
          }

          if(!error && this.page < this.total) {
              this.page++;
          }

          if(this.page == this.total) this.next_bttn = i18n.t('general.confirm');
        }
      }
    },
    previous() {
      if(this.page == this.total) this.next_bttn = i18n.t('general.continue');

      if( this.page == 4 && ( this.order.to.file == this.order.from.type ) ){
        this.page = 1;
        return;
      }

      if(this.page > 1) {
        this.page--;
      }

      if( this.page == 3 && ( typeof this.questions[ this.order.to.file ] == 'undefined' || Object.keys( this.questions[ this.order.to.file ] ).length == 0 ) ){
          this.page--;
      }
      if( this.page == 2 && ( typeof this.sizes[ this.order.to.file ] == 'undefined' || Object.keys( this.sizes[ this.order.to.file ] ).length == 0 ) ){
          this.page--;
      }
    },
    cleanFile(){
      this.order.to.filename = false;
      this.order.to.size = '';
      this.order.params = {};
      this.order.method = false;
      this.order.units = false;
      this.order.billed = false;
      this.order.shipped = false;
      this.order.custom_ship = "";
      this.order.custom = { restaurant: '' };
    },
    setCurrentFile( order ){
      this.order.from.filename = order.name;
      this.order.from.reference = order.reference;
      this.order.from.link = order.file;
      this.order.from.image = order.thumb;
      this.order.from.type = order.type.id;
      this.order.to.file = order.type.id;
    },
    loadFile( input ){
        var file = document.getElementById( input ).files[0];
        document.getElementsByClassName( 'next' )[0].classList.add( 'disabled' );
        this.next_bttn = i18n.t('views.order.upload');

        var self = this;
        uploader.upload( file, 'temp', function( data ){
            document.getElementsByClassName( 'next' )[0].classList.remove( 'disabled' );
            self.next_bttn = i18n.t('general.continue');

            switch( input ){
                case 'input-file-question':   self.order.params.custom_file = data.Key;
                                              break;
                case 'input-file-customize':  self.order.custom_file = data.Key;
                                              break;
            }
        });
    }
  },
  mounted() {
  },
  created() {
    this.$store.commit('setTitle', i18n.t('views.orders.name'));
    this.$store.commit('setMenuVisible', false);

    if( this.type == 'new' ){
        var order = this.$store.getters['files/getCurrentFile'];

        if( order ){
            this.setCurrentFile( order );    
        }
        else{
            var self = this;
            this.$store.dispatch( 'files/loadFile', this.$route.params.id ).then( function(){
                self.setCurrentFile( self.$store.getters['files/getCurrentFile'] );    
            });
        }
    }
    else{
        var order = this.$store.getters[ 'orders/getCurrentOrder' ];
        if( order ){
            this.order = JSON.parse( JSON.stringify( order ) );
        }
        else{
            var self = this;
            this.$store.dispatch( 'orders/loadOrder', this.$route.params.id ).then( function(){
                order = self.$store.getters['orders/getCurrentOrder'];

                if( !order ) self.$router.replace( { name: 'cart' } ); 
                else self.order = JSON.parse( JSON.stringify( order ) );
            });
        }
    }
  },
  watch: {
      page() {
        window.scrollTo(0,0);
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .wizard {
    margin: 25px auto;
    width: 80%;
    overflow: hidden;

    .summary {
      width: 30%;
      float: left;
      padding: 15px;
      background: #eee;

      .from {
        width: 100%;
        overflow: hidden;

        .label {
          text-align: left;
          text-transform: uppercase;
          font-size: 14px;
          margin-bottom: 10px;
        }
        img {
          margin: 0 auto;
          max-height: 600px;
          width: 100%;
        }
        .meta {
          /*width: calc( 100% - 100px);*/
          width: 100%;
          float: left;

          .name {

          }
        }
      }
      .to {
        width: 100%;
        overflow: hidden;
        margin-top: 25px;

        .label {
          text-align: left;
          text-transform: uppercase;
          font-size: 14px;
          margin-bottom: 10px;
        }
        .item {
          overflow: hidden;
          text-align: left;
          font-size: 13px;
          
          label {
            width: 100px;
            float: left;
          }
          .value {
            width: calc( 100% - 100px );
            float: left;
            word-break: break-all;
          }
        }
      }

    }
    .box {
      width: 70%;
      float: left;

      .step {
        padding: 15px 25px;

        .title {
          text-align: center;
          margin: 0;
          margin-bottom: 5px;
        }
        .desc {
          text-align: center;
          margin: 0;
          margin-bottom: 40px;
        }

        .required {
          color: #DD2C00;
        }

        input, select, textarea {
          border-radius: 3px;
          border: 1px solid #ccc;
          padding: 15px;
          width: 500px;
          margin: 5px 0;
          max-width: 500px;
        }
        .direction-select {
          border-radius: 3px;
          border: 1px solid #ccc;
          padding: 10px 15px 0 15px;
          width: 500px;
          margin: auto;
          margin-top: 5px;
          max-width: 500px;
        }

        label{
          display: block;
          margin-top: 15px;
        }

        textarea, input[type="file"] {
          width: 500px;
          max-width: 500px;
        }
        input[type="radio"] {
          text-align: left;
          width: auto;
          margin: 0 10px;
        }
        .question {
          text-align: center;
          max-width: 400px;
          margin: 0 auto;
          margin-bottom: 35px;

          .title {
            margin-bottom: 10px;
          }

          label {
            margin-right: 20px;
          }
          textarea {
            max-width: 100%;
            width: 100%;
          }
        }

        .param.units {
          overflow: hidden;

          .label {
            display: block;
            float: left;
            width: 150px;
            padding: 20px 0;
          }
          .container {
            display: block;
            float: left;
            width: calc( 100% - 150px );
            padding: 0;
            text-align: left;

            select {
              max-width: 100px;
            }
            input {
              max-width: 150px;
            }
          }
        }

        .box-info {
          text-align: left;
          padding: 15px;
          border-radius: 3px;
          background-color: #eee;

          .title {
            font-size: 17px !important;
            margin-bottom: 15px;
            font-weight: bold;
          }
          p {
            font-size: 14px;
          }
        }

        .subtitle {
          font-weight: bold;
          margin-top: 25px;
          font-size: 15px;
          display: block;
        }
        .caption {
          font-size: 14px;
          color: #666;
          margin-bottom: 5px;
        }

        .file-customize {
          .container {
            float: left;
            padding: 8px;

            input, select {
              border-radius: 3px;
              border: 1px solid #ccc;
              padding: 15px;
            }
            input {
              padding: 7px;
            }
            .address {
              min-width: 400px;
              clear: both;
              margin-top: 5px;
              display: block;
            }
            .single {
              padding: 5px;
              margin-left: 15px;
              width: 100px; margin-right: 5px;
            }
          }
        }

      }
      .buttons {
        margin: 25px auto;

        .bttn {
          display: inline-block;
          padding: 15px 20px;
          background: #ccc;
          border-radius: 5px;
          text-align: center;
          margin: 0 5px;
          width: 200px;
          cursor: pointer;

          &.next {
            background: var(--main_color);
            font-family: Speedee-Bold;
          }
          &.previous {

          }
          &.disabled {
             opacity: 0.5;
          }
        }
      }

      .message {
        width: 400px;
        margin: 0 auto;
      }
      
    }

  }

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
